import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/supplierService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchSuppliers = createAsyncThunk("suppliers/fetchAll", async (params) => {
  const res = await svc.getSuppliers(params);
  return res.data;
});

export const createSupplierThunk = createAsyncThunk("suppliers/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createSupplier(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create supplier."));
  }
});

export const updateSupplierThunk = createAsyncThunk("suppliers/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateSupplier(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update supplier."));
  }
});

export const deleteSupplierThunk = createAsyncThunk("suppliers/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteSupplier(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete supplier."));
  }
});

const supplierSlice = createSlice({
  name: "suppliers",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSuppliers.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchSuppliers.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createSupplierThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateSupplierThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((s) => s.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteSupplierThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((s) => s.id !== action.payload);
      });
  },
});

export default supplierSlice.reducer;
